import React, { useState } from "react"
import * as styles from "./RotatingMenu.module.css"
import classNames from "classnames"
import useDeviceType from "../../../../hooks/useDeviceType"

import Touchfree_Xpress from "../../../../images/landing/touchfree-xpress.webp"
// import Touchfree_Xpress from "../../../../images/landing/touchfree-xpress.inline.svg"
import App_Widget from "../../../../images/landing/app-widget.inline.svg"
import SMS from "../../../../images/landing/sms.inline.svg"
import Post_Call_Ivr from "../../../../images/landing/post-call-ivr.inline.svg"
import Social_Media from "../../../../images/landing/social-media.inline.svg"
import QR_Code from "../../../../images/landing/QR-code.inline.svg"
import Email from "../../../../images/landing/email.inline.svg"

import ArrowLeftSVG from "../../../../images/icon/arrow-left.inline.svg"
import ArrowRightSVG from "../../../../images/icon/arrow-right.inline.svg"

const details = [
  {
    // svg: Touchfree_Xpress,
    img: Touchfree_Xpress,
    title: "TouchfreeXPress",
    text: "Portable touchless customer feedback kiosk",
  },
  {
    svg: App_Widget,
    title: "App Widget",
    text: "Feedback widget for the digital screen,website and mobile apps.",
  },
  {
    svg: SMS,
    title: "SMS",
    text: "Feedback collection with 2-way SMS and Feedback link in SMS and Whatsapp.",
  },
  {
    svg: Post_Call_Ivr,
    title: "Post call IVR",
    text: "Feedback collection with IVR at the end of call.",
  },
  {
    svg: Social_Media,
    title: "Social Media",
    text: "Feedback from social media and business review websites.",
  },
  {
    svg: QR_Code,
    title: "QR Code",
    text: "feedback collection with QR Code and feedback links.",
  },
  {
    svg: Email,
    title: "Email",
    text: "Feedback widget in email and email signature.",
  },
]

const RotatingMenu = () => {
  const [activeItem, setActiveItem] = useState(0)

  const DeviceType = useDeviceType()

  const handleMenuArrow = (direction: "left" | "right") => {
    if (direction === "left") {
      setActiveItem(preActiveItem => {
        const newActiveItem = preActiveItem - 1
        if (newActiveItem >= 0) return newActiveItem
        return 7 - 1
      })
    }

    if (direction === "right") {
      setActiveItem(preActiveItem => {
        const newActiveItem = preActiveItem + 1
        if (newActiveItem <= 6) return newActiveItem
        return 0
      })
    }
  }

  return (
    <div className={styles.container}>
      {/* Description */}
      <div className={styles.description}>
        <h4>{details[activeItem].title}</h4>
        <p>{details[activeItem].text}</p>
      </div>

      {/* Items */}
      <div className={styles.polygonBox}>
        <ul
          className={styles.itemContent}
          style={
            DeviceType !== "tablet" && DeviceType !== "mobile"
              ? { transform: `rotate(calc(-360deg / 7 * ${activeItem}))` }
              : {
                  transform: `rotate(calc(-360deg / 7 * ${activeItem} + 90deg))`,
                }
          }
        >
          {details.map(({ svg: SVG, img, title }, index) => (
            <li
              key={title}
              className={classNames(styles.item, {
                [styles.active]: index === activeItem,
              })}
              style={{
                transform: `translateY(-50%) rotate(calc(360deg / 7 * ${index}))`,
              }}
              onClick={() => setActiveItem(index)}
            >
              <div
                style={
                  DeviceType !== "tablet" && DeviceType !== "mobile"
                    ? index === activeItem
                      ? {
                          transform: `rotate(calc(360deg / -7 * ${index} + 360deg / 7 * ${activeItem})) scale(2.2)`,
                        }
                      : {
                          transform: `rotate(calc(360deg / -7 * ${index} + 360deg / 7 * ${activeItem})) scale(1.2)`,
                        }
                    : index === activeItem
                    ? {
                        transform: `rotate(calc(360deg / -7 * ${index} + 360deg / 7 * ${activeItem} + -90deg)) scale(1.9)`,
                      }
                    : {
                        transform: `rotate(calc(360deg / -7 * ${index} + 360deg / 7 * ${activeItem} + -90deg)) scale(0.9)`,
                      }
                }
              >
                {SVG ? <SVG /> : <img src={img} alt={title} />}
              </div>
            </li>
          ))}
        </ul>
      </div>

      {(DeviceType === "tablet" || DeviceType === "mobile") && (
        <div className={styles.arrowContent}>
          <div onClick={() => handleMenuArrow("left")}>
            <ArrowLeftSVG />
          </div>
          <div onClick={() => handleMenuArrow("right")}>
            <ArrowRightSVG />
          </div>
        </div>
      )}
    </div>
  )
}

export default RotatingMenu
